import {
  Button,
  Checkbox,
  FormControl,
  Grid,
  InputBase,
  makeStyles,
  withStyles,
  MenuItem,
  Paper,
  Select,
  InputAdornment,
  OutlinedInput,
} from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { Pagination, PaginationItem } from "@material-ui/lab";
import SearchIcon from "@material-ui/icons/Search";

import ActionMessages from "../../../common-components/ActionMessages";
import Loading from "../../../common-components/Loading";
import {
  getOvertimeTypesListAPI,
  updateOvertimeTypesAPI,
} from "../../../api/financial-management-api";
import { getPaginationPageNumber } from "../../../shared-resources/utils";
import { AntSwitch } from "../../../common-components/AntSwitch";
import { convertValuesFMPipeline } from "../../../shared-resources/utils";

const OtTypes = () => {
  const useStyles = makeStyles((theme) => ({
    tablePaper: {
      borderRadius: "12px",
      padding: "12px",
      marginTop: "12px",
    },
    cancelBtn: {
      fontSize: "12px",
      padding: "3px 8px !important",
      textTransform: "none",
      border: "0.5px solid #0176D3",
      color: "#0176D3",
      borderRadius: "25px",
    },
    updateBtn: {
      fontSize: "12px",
      fontWeight: "600",
      padding: "4px 8px !important",
      textTransform: "none",
      color: "#ffff",
      backgroundColor: "#0176d3",
      borderRadius: "25px",
      marginRight: "8px",
    },
    searchIcon: {
      color: "#ccc",
    },
    searchTextField: {
      borderRadius: "25px",
      fontSize: "14px",
      height: "36px",
    },
  }));

  const classes = useStyles();

  const [msg, setMsg] = useState({ type: "", text: "" });
  const [tableData, setTableData] = useState([]);
  const [tableDataOrigin, setTableDataOrigin] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isDataChanged, setIsDataChanged] = useState(false);
  const [search, setSearch] = useState("");

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const BootstrapInput = withStyles((theme) => ({
    root: {
      "label + &": {
        marginTop: theme.spacing(3),
      },
    },
    input: {
      borderRadius: 4,
      position: "relative",
      backgroundColor: theme.palette.background.paper,
      border: "1px solid #ced4da !important",
      fontSize: 13,
      padding: "4px",
      transition: theme.transitions.create(["border-color", "box-shadow"]),
      // Use the system font instead of the default Roboto font.
      fontFamily: [
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(","),
      "&:focus": {
        borderRadius: 4,
        borderColor: "#80bdff",
        boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
      },
    },
  }))(InputBase);

  const isClosed = () => {
    setMsg({ text: "", type: "" });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage - 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const onUpdateClick = () => {
    setLoading(true);
    updateOvertimeTypesAPI(tableData).then((res) => {
      setIsDataChanged(false);
      setTableDataOrigin(tableData);
      if (res.status === 200) {
        setMsg({ type: "success", text: "Data updated successfully" });
      } else {
        setMsg({ type: "error", text: "Failed to update data" });
      }
      setLoading(false);
    });
  };

  const onCancelClick = () => {
    setTableData(tableDataOrigin);
    setIsDataChanged(false);
  };

  useEffect(() => {
    getOvertimeTypesListAPI().then((res) => {
      setLoading(false);
      setTableData(res.data);
      setTableDataOrigin(res.data);
    });
  }, []);

  const onChangeValue = (e, id) => {
    const changedData = JSON.parse(JSON.stringify(tableData));
    setIsDataChanged(true);
    changedData.forEach((val) => {
      if (val.otTypeId === id) {
        val.isActive = e.target.checked;
        val.isUpdated = true;
      }
    });
    setTableData(changedData);
  };

  const filterData = (data) => {
    const searchText = search.trim().toLowerCase();
    const changedData = JSON.parse(JSON.stringify(data));
    if (searchText) {
      return changedData.filter((val) =>
        val.otDescription.toLowerCase().includes(searchText),
      );
    }
    return changedData;
  };

  return (
    <>
      <Paper elevation={0} className={classes.tablePaper}>
        <Grid container spacing={2}>
          <Grid item lg={6}>
            <FormControl variant="outlined">
              <OutlinedInput
                className={classes.searchTextField}
                type="text"
                placeholder="Search"
                onChange={(e) => setSearch(e.target.value)}
                value={search}
                endAdornment={
                  <InputAdornment position="start">
                    <SearchIcon className={classes.searchIcon} />
                  </InputAdornment>
                }
              />
            </FormControl>
          </Grid>
          <Grid item lg={6}>
            <Button
              variant="outlined"
              className={classes.cancelBtn}
              color="primary"
              //   onClick={() => cancelUpdate()}
              //   disabled={!isEnabled}
              disabled={!isDataChanged}
              onClick={onCancelClick}
              style={{ marginTop: "4px", float: "right" }}
            >
              Cancel
            </Button>
            <Button
              className={classes.updateBtn}
              variant="contained"
              color="primary"
              onClick={onUpdateClick}
              disabled={!isDataChanged}
              //   disabled={!isEnabled}
              style={{ marginTop: "4px", float: "right" }}
            >
              Update
            </Button>
          </Grid>
        </Grid>
        <table style={{ marginTop: "12px" }} className="generalSettingsTable">
          <thead>
            <tr>
              <td>OT Description</td>
              <td>Overtime</td>
              <td>Factor</td>
              <td>Fixed Amount</td>
              <td>Is Active?</td>
            </tr>
          </thead>
          <tbody>
            {filterData(tableData)
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((tableItem, index) => (
                <tr key={index}>
                  <td style={{ display: "flex", alignItems: "center" }}>
                    {tableItem.otDescription}
                  </td>
                  <td style={{ width: "90px" }}>
                    <Checkbox
                      className="customCheckBox"
                      checked={tableItem.isOvertime}
                      color="primary"
                      disabled
                    />
                  </td>
                  <td>{tableItem.factor}</td>
                  <td>{convertValuesFMPipeline(tableItem.fixedAmt)}</td>
                  <td>
                    <AntSwitch
                      checked={tableItem.isActive}
                      onChange={(e) => onChangeValue(e, tableItem.otTypeId)}
                    />
                  </td>
                </tr>
              ))}
          </tbody>
        </table>

        <Grid container className={classes.paginationSection} spacing={0}>
          <Grid item lg={12}>
            <div style={{ float: "right", marginTop: "6px" }}>
              <Pagination
                count={Math.ceil(tableData.length / rowsPerPage)}
                showFirstButton
                showLastButton
                page={page + 1}
                onChange={handleChangePage}
                color="primary"
                style={{ float: "right" }}
                renderItem={(item) => (
                  <PaginationItem
                    {...item}
                    page={getPaginationPageNumber(
                      item.page - 1,
                      tableData.length,
                      rowsPerPage,
                    )}
                  />
                )}
              />
            </div>
            <div style={{ float: "right", marginTop: "6px" }}>
              <div style={{ float: "left", marginTop: "4px" }}>Showing</div>
              <FormControl className="tableRowsDdl">
                <Select
                  labelId="demo-customized-select-label"
                  id="demo-customized-select"
                  value={rowsPerPage}
                  onChange={handleChangeRowsPerPage}
                  input={<BootstrapInput />}
                >
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={15}>15</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={25}>25</MenuItem>
                </Select>
              </FormControl>
            </div>
          </Grid>
        </Grid>
      </Paper>

      {msg.text && (
        <ActionMessages
          type={msg.type}
          isClosed={isClosed}
          message={msg.text}
        />
      )}
      {loading && <Loading />}
    </>
  );
};

export default OtTypes;
